
import { useAuth } from "../context/AuthContext";
import Logo from "./Logo";
import { NavLink } from "react-router-dom";

export default function InternalHeader() {
  const { user, logout } = useAuth();

  return (
    <>
      {/* HEADER */}
      <header className="border-b border-neutral-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-2.5">
          <Logo size="medium" />

          <div className="flex items-center gap-3">
            <div className="hidden text-right md:block">
              <div className="text-xs font-medium text-neutral-900">
                {user?.email}
              </div>

              <div className="text-[11px] text-neutral-500">
                Intern användare
              </div>
            </div>

            <button
              onClick={logout}
              className="
                rounded-lg
                border
                border-neutral-300
                px-3
                py-1.5
                text-xs
                font-medium
                text-neutral-700
                transition
                hover:bg-neutral-900
                hover:text-white
              "
            >
              Logga ut
            </button>
          </div>
        </div>
      </header>

      {/* MENY */}
      <nav className="border-b border-neutral-200 bg-white">
        <div className="mx-auto flex max-w-6xl gap-1.5 overflow-x-auto px-5 py-1.5">
          <InternalLink to="/intern">
            Översikt
          </InternalLink>

          <InternalLink to="/intern/rapporter">
            Rapportera
          </InternalLink>

          <InternalLink to="/intern/dokument">
            Dokument
          </InternalLink>

          <InternalLink to="/intern/aktiviteter">
            Aktiviteter
          </InternalLink>

          <InternalLink to="/intern/installningar">
            Inställningar
          </InternalLink>
        </div>
      </nav>
    </>
  );
}

function InternalLink({ to, children }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `whitespace-nowrap rounded-lg px-3 py-1.5 text-xs font-medium transition ${
          isActive
            ? "bg-[#E8F7F5] text-[#3BAFA3]"
            : "text-neutral-600 hover:bg-neutral-100"
        }`
      }
    >
      {children}
    </NavLink>
  );
}

